<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>

  <div id="popup"
       @focus="handleFocus"
       @focusout="handleFocusOut"
       tabindex="0"
       ref="frame"
       v-if="isSidebarActiveLocal" :class="isSidebarActiveLocal ? 'active' : ''">
    <div class="popup-cont"
         tabindex="1">
      <h2 class="popup-heading">{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} BLOG</h2>
      <div class="popup-item">
        <div class="img-container w-full mx-auto flex items-center justify-center">
          <img :src="dataImg"  alt="img" class="responsive" :class="imgCss">
        </div>
        <div class="upload-img mt-5 text-center p-6">
          <input type="file" class="hidden" ref="uploadImgInput" @change="updateCurrImg" name="content-image" accept="image/*" />
          <vs-button @click="$refs.uploadImgInput.click()">Upload Image</vs-button>
          <vs-button type="flat" color="#999" @click="(() => {
            dataImg = require('@/assets/images/pages/register/upload_image.png')
            imgCss = 'm-w-150'
          })">Remove Image</vs-button>
          <div class="text-danger text-sm" v-show="errors.has('content-image')">{{ errors.first('content-image') }}</div>
        </div>
      </div>
      <div class="popup-item">
        <h4>Blog Name</h4>
        <p>Set the title of blog.</p>
        <input type="text" class="pop-input" placeholder="Blog Name" v-model="name" name="Blog Name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('Blog Name')">{{ errors.first('Blog Name') }}</span>
      </div>
      <div class="popup-item">
        <h4>Short Content</h4>
        <p>Describe your content with a brief description.</p>
        <textarea class="pop-textarea"
                  placeholder="Example: Select a size"
                  v-model="shortContent" name="Short Content" v-validate="'required'"></textarea>
        <span class="text-danger text-sm" v-show="errors.has('Short Content')">{{ errors.first('Short Content') }}</span>
      </div>
      <div class="popup-item">
        <h4>Long Content</h4>
        <p>Add html code for display.</p>
        <vue-editor :editorOptions="editorSettings" v-model="longContent"></vue-editor>
      </div>
      <div class="popup-item">
        <h4>Restaurants</h4>
        <multiselect name="Restaurants" v-model="selected_restaurants"
                     label="label" track-by="label" :multiple="true"
                     :options="multi_select_options">
        </multiselect>
        <span class="text-danger text-sm" v-show="errors.has('Restaurants')">{{ errors.first('Restaurants') }}</span>
      </div>
      <div class="popup-item">
        <div class="tr-button blue-button popup-button" :class="isFormValid ? '' : 'inactive'" @click="submitData">{{ this.data.add === true ? "Add New" : "Update" }} Blog</div>
        <div @click="isSidebarActiveLocal = false" class="tr-button popup-button">Cancel</div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import { VueEditor, Quill } from 'vue2-editor'
import htmlEditButton from 'quill-html-edit-button'

Quill.register({
  'modules/htmlEditButton': htmlEditButton
})
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    VueEditor,
    Quill
  },
  data () {
    return {
      id: null,
      name: '',
      shortContent: '',
      longContent: '',
      imgCss: 'm-w-150',
      dataImg: require('@/assets/images/pages/register/upload_image.png'),
      uploadImg: null,
      contentType: null,
      content_type_options: [
        {label: 'Page', value: 'page'},
        {label: 'Slide', value:'slide'},
        {label: 'Campaign', value:'campaign'},
        {label: 'Blog', value:'blog'}
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      editorSettings: {
        modules: {
          htmlEditButton: {
            prependSelector: 'div#myelement' // a string used to select where you want to insert the overlayContainer, default: null (appends to body),
          }
        }
      },
      selected_restaurants: []
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) return

      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
        this.imgCss = 'm-w-150'
        this.uploadImg = null
      } else {
        const { name, id, contentType, shortContent, longContent, contentImageUrl, restaurants } = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.name = name
        this.contentType = contentType
        this.shortContent = shortContent
        this.longContent = longContent
        this.dataImg = (contentImageUrl !== null) ? contentImageUrl : require('@/assets/images/pages/register/upload_image.png')
        this.uploadImg = null
        this.imgCss = ''
        this.restaurants = restaurants
        this.selected_restaurants = this.restaurants.map(restaurant => {
          return  {
            label: restaurant.restaurant.user_property['Restaurant-Name'],
            value: restaurant.restaurant.id
          }
        })
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.shortContent && this.longContent && (this.uploadImg || this.dataImg.includes('restapi'))
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    multi_select_options () {
      return this.restaurantlist.map(user => {
        const option = {
          label: user.user_property['Restaurant-Name'],
          value: user.id
        }
        return option
      })
    },
    restaurant_select () {
      return this.restaurantlist.map(restaurant => {
        return  {
          label: restaurant.user_property['Restaurant-Name'],
          value: restaurant.id
        }
      })
    },
    restaurantlist () {
      return this.$store.state.api.restaurantlist || JSON.parse(localStorage.getItem('restaurantlist'))
    }
  },
  methods: {
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
          this.imgCss = ''
        }
        reader.readAsDataURL(input.target.files[0])
        this.uploadImg = input.target.files[0]
      }
    },
    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.shortContent = ''
      this.longContent = ''
      this.dataImg = require('@/assets/images/pages/register/upload_image.png')
      this.imgCss = 'm-w-150'

      this.restaurants = []
      this.selected_restaurants = []
    },
    submitData () {

      this.$validator.validateAll().then(result => {
        this.$vs.loading()
        if (result) {
          const obj = {
            contentType: 'blog',
            name: this.name,
            shortContent: this.shortContent,
            longContent: this.longContent,
            restaurant_id: 0,
            restaurants: this.selected_restaurants.map(rest => rest.value)
          }

          if (this.uploadImg) {
            obj['contentImage'] = this.uploadImg
          }

          if (!this.add) {
            obj['contentId'] = this.id
          }

          this.$store.dispatch('api/uploadContent', obj,  event => {
            this.progress = Math.round((100 * event.loaded) / event.total)
          }).then((response) => {
            this.$vs.notify({
              title: 'Content Saved',
              text: response.data.message,
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
            this.isSidebarActiveLocal = false
          }).catch(err => {
            console.error(err)
            if (err.message.contains('Content saved')) {
              this.$vs.notify({
                title: 'Content Saved',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-check',
                color: 'success'
              })
            } else {
              this.$vs.notify({
                title: 'Error',
                text: err.message,
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
              })
            }
            this.$vs.loading.close()
          })

        }
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
  .m-w-150 {
    max-width: 150px;
  }
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
